import { ca } from '@cian/analytics';

export function trackShowMoreClick() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click_sopr',
    category: 'Card',
    label: 'RosreestrInfo',
    useLastProducts: true,
  });
}

export const trackRosreestrFlatSaleShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Show_sopr',
    label: 'RosreestrInfo',
    category: 'Card',
    useLastProducts: true,
  });
};
